var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrerollIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "36px",
    viewBox: "0 0 48 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12.0_Creatives_21",
    transform: "translate(-1149.000000, -487.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(130.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(926.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(0.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop-(1)",
    transform: "translate(63.000000, 36.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    points: "1.99115625 0.872435912 5.889 0.872435912 5.889 5.3530943 1.99115625 5.3530943"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    points: "8.7015 0.872435912 12.581625 0.872435912 12.581625 5.3530943 8.7015 5.3530943"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    points: "15.3940312 0.872435912 45.9955312 0.872435912 45.9955312 5.3530943 15.3940312 5.3530943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5775,28.2350406 L20.182875,30.3302744 L27.8033438,30.3302744 L29.4092813,28.2350406 L45.9955313,28.2350406 L45.9955313,0.591143986 L1.99115625,0.591143986 L1.99115625,28.2350406 L18.5775,28.2350406 Z M6.4,7.82608696 L6.4,5.47826087 L19.2,5.47826087 L19.2,7.82608696 L6.4,7.82608696 Z M6.4,12.5217391 L6.4,10.173913 L19.2,10.173913 L19.2,12.5217391 L6.4,12.5217391 Z M21.6,7.82608696 L21.6,5.47826087 L30.4,5.47826087 L30.4,7.82608696 L21.6,7.82608696 Z M21.6,12.5217391 L21.6,10.173913 L30.4,10.173913 L30.4,12.5217391 L21.6,12.5217391 Z M32.8,7.82608696 L32.8,5.47826087 L41.6,5.47826087 L41.6,7.82608696 L32.8,7.82608696 Z M32.8,12.5217391 L32.8,10.173913 L41.6,10.173913 L41.6,12.5217391 L32.8,12.5217391 Z M21.6,26.6086957 L21.6,24.2608696 L30.4,24.2608696 L30.4,26.6086957 L21.6,26.6086957 Z M32.8,26.6086957 L32.8,24.2608696 L41.6,24.2608696 L41.6,26.6086957 L32.8,26.6086957 Z M6.4,26.6086957 L6.4,24.2608696 L19.2,24.2608696 L19.2,26.6086957 L6.4,26.6086957 Z M19.696125,15.1187194 L19.696125,21.3791716 L6.496125,21.3795889 L6.496125,15.1191367 L19.696125,15.1187194 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    points: "30.5740313 31.5080903 28.9680938 33.0744867 19.0179375 33.0744867 17.4125625 31.5080903 0 31.5080903 0 33.0618634 2.999625 35.9886573 44.9870625 35.9886573 47.9866875 33.0618634 47.9866875 31.5080903"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrerollIcon);
export default __webpack_public_path__ + "static/media/PrerollIcon.ff23d7ce503893a154619cf00955a02d.svg";
export { ForwardRef as ReactComponent };